const CARDS = 25;

let cardArray = [];

for (let index = 1; index < CARDS; index++) {
  cardArray.push(index);
}

export const exampleItems = cardArray;
